import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
interface TotalControlSectionProps {
  onOpenForm: () => void;
}
const TotalControlSection = ({
  onOpenForm
}: TotalControlSectionProps) => {
  return <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Contenu texte */}
          <div>
            <h2 className="text-4xl md:text-5xl font-normal text-gray-900 mb-6">
              Contrôle total de l'événement, à portée de main
            </h2>
            <p className="text-xl text-gray-500 mb-10">
              De la logistique aux changements de dernière minute, notre technologie vous offre une visibilité complète et une tranquillité d'esprit.
            </p>
            
            <Button size="lg" className="bg-cta-green text-cta-green-foreground hover:bg-cta-green/90 hover:shadow-xl hover:shadow-cta-green/30 rounded-md transition-all duration-300 ease-out transform hover:scale-105 group font-bold" onClick={onOpenForm}>
              Commencer gratuitement
              
            </Button>
          </div>
          
          {/* Maquette téléphone */}
          <div className="flex justify-center">
            <div className="relative w-72 md:w-80">
              {/* Appareil téléphone */}
              <Card className="overflow-hidden rounded-[40px] border-0 shadow-2xl">
                <CardContent className="p-2 bg-gray-900">
                  {/* Écran téléphone */}
                  <div className="relative overflow-hidden rounded-[32px] aspect-[9/19]">
                    <img src="/lovable-uploads/229570ec-54e9-4004-b6fe-44e3677353aa.png" alt="Interface de l'application événementielle Naboo" className="w-full h-full object-cover" />
                    
                    {/* Réflexion écran overlay */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-white/20 pointer-events-none"></div>
                  </div>
                  
                  {/* Encoche inférieure */}
                  <div className="absolute bottom-[10px] left-1/2 transform -translate-x-1/2 w-1/3 h-1 bg-gray-700 rounded-full"></div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TotalControlSection;